import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterText'
})
export class FilterItemsPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    // A lista pode ser de veículos (placa) ou de qualquer cadastro com nome,
    // como os produtos que viram cobertura no pick-list.
    return items.filter(item => {
      const campos = [item?.placa, item?.nome, item?.name, item?.descricao]
      return campos.some(campo => String(campo ?? '').toLowerCase().includes(searchText))
    });
  }
}
